/** Discriminated EN contract for notification actions in the wire body. */
export type NotificationAction =
  | { kind: 'open' | 'complete'; notificationId: string; linkedWorkOrderId: string }
  | { kind: 'detail'; notificationId: string }

/** Presentation is separate from the canonical instruction and action payload. */
export interface ClickedActionWireOptions {
  clickedActionLabel?: string
  intentId?: string
  notificationAction?: NotificationAction
}
export function clickedActionWireOptions(options?: {
  displayText?: string
  intentId?: string
  notificationAction?: NotificationAction
}): ClickedActionWireOptions | undefined {
  const label = options?.displayText
  const clickedActionLabel = label && label.length <= 300 ? label : undefined
  if (!clickedActionLabel && !options?.intentId && !options?.notificationAction) return undefined
  return {
    ...(clickedActionLabel ? { clickedActionLabel } : {}),
    ...(options?.intentId ? { intentId: options.intentId } : {}),
    ...(options?.notificationAction ? { notificationAction: options.notificationAction } : {}),
  }
}

/** Only verified server click metadata can replace user-bubble presentation. */
export function persistedClickLabel(metadata: unknown): string | undefined {
  if (!metadata || typeof metadata !== 'object' || Array.isArray(metadata)) return undefined
  const click = (metadata as Record<string, unknown>).actionClickPresentation
  if (!click || typeof click !== 'object' || Array.isArray(click)) return undefined
  const { source, label, locale } = click as Record<string, unknown>
  return source === 'suggested_action' &&
    typeof label === 'string' &&
    label.trim().length > 0 &&
    label.length <= 300 &&
    /^[^\p{Cc}]*$/u.test(label) &&
    ['pt-BR', 'en-US', 'es-419'].includes(String(locale))
    ? label
    : undefined
}
